/**
 * @name: hasEmpty
 * @user: cfj
 * @date: 2023/3/20 18:09
 * @desc: 判空
 */
export function getDataTypeof(data) {
    const s = Object.prototype.toString.call(data);
    return s.match(/\[object (.*?)\]/)[1].toLowerCase();
}
export const hasEmpty = (value) => {
  if (getDataTypeof(value) === "array") {
    return !value.length;
  }
  if (getDataTypeof(value) === "string") {
    const varStr = value.trim();
    return varStr === "";
  }
  if (getDataTypeof(value) === "object") {
    return !Reflect.ownKeys(value).length;
  }
  if (getDataTypeof(value) === "null") {
    return true;
  }
  if (getDataTypeof(value) === "undefined") {
    return true;
  }
  if (typeof value === "number") {
    return false;
  }
  return !value;
};
